import GravityCsvV1Adapter from 'teacher-ui-client/adapters/gravity/csv-v1-adapter'
import { join } from 'teacher-ui-client/utils/uri'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import { assert } from '@ember/debug'

export default class ImportScheduleAdapter extends GravityCsvV1Adapter {
  @service session!: SessionService

  @service subscriptionType!: SubscriptionTypeService

  urlForFindRecord(id: string, modelName: string) {
    const { host, namespace } = this
    const { currentTeacher, currentSchool } = this.session
    const subscriptionType = this.subscriptionType.current

    assert('currentTeacher missing', currentTeacher)
    assert('currentSchool missing', currentSchool)
    assert('subscriptionType missing', subscriptionType)

    const isSubco = currentTeacher.subcoFor(subscriptionType)
    const type = isSubco ? 'schools' : 'teachers'
    const typeId = isSubco ? currentSchool.id : currentTeacher.id

    const path = this.pathForType(modelName)

    return join(host, namespace, type, typeId, subscriptionType, path, id).href
  }
}
